import { useEffect, useState } from 'react';

import { getAgreementStatusOnly } from '../api';
import { AGREEMENT_STATUS_SIGNED } from '../constants';

type UseProductAgreement = {
  isAgreementSigned: boolean;
  fetchingAgreement: boolean;
};

export const useProductAgreement = (merchantId: number): UseProductAgreement => {
  const [isAgreementSigned, setIsAgreementSigned] = useState<boolean>(false);
  const [fetchingAgreement, setFetchingAgreement] = useState<boolean>(true);

  useEffect(() => {
    getAgreementStatusOnly(merchantId)
      .then((res) => {
        return setIsAgreementSigned(
          !!res.find((agreement) => agreement.status === AGREEMENT_STATUS_SIGNED)
        );
      })
      .finally(() => setFetchingAgreement(false));
  }, []);

  return {
    isAgreementSigned,
    fetchingAgreement
  };
};
